let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("in0CI"), load("3XYal"), load("1Ojgx")]).then(() => parcelRequire('4E1b5'));